<template>
  <div class="pa-0" style="position: relative">
    <v-row class="s-btn-filter">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn
          color="primary"
          class="mb-2 btn-export-excel"
          @click="exportExcel"
        >
          <v-icon>mdi-download</v-icon>Xuất file Excel
        </v-btn>
        <v-menu
          :internal-activator="true"
          v-model="openMenu"
          content-class="menu__customer--filter no-contain overflow-visible"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin-right: 10px"
              class="mb-2 btn-filter-condition"
              color="primary"
              dark
              v-on="on"
            >
              <span>Lọc theo điều kiện</span>
              <v-icon style="margin-left: 10px; margin-right: -20px">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-card
            class="mx-auto overflow-visible"
            width="800px"
            style="margin-top: 0px; margin-bottom: 0px;"
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content class="overflow-visible">
                <v-row class="align-center">
                  <v-col cols="12" md="10">
                    <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
                  </v-col>
                  <v-col cols="12" md="2" class="text-right">
                    <v-icon aria-label="Close" class="icon-close" @click="openMenu = false">mdi-close</v-icon>
                  </v-col>
                </v-row>
                <div></div>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="filterForm.orderCode"
                      label="Mã đơn"
                      placeholder="Nhập mã đơn"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="filterForm.receiptCode"
                      label="Mã phiếu thu"
                      placeholder="Nhập mã phiếu thu"
                      clearable
                    />
                  </v-col>
                </v-row>
                <div></div>
                <v-row>
                  <v-col cols="12" md="6" class="py-0">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      label="Ngày tạo"
                      v-model="createdAtRange"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      label="Ngày thanh toán"
                      v-model="paymentAtRange"
                    />
                  </v-col>
                </v-row>
                <div class="d-flex text-center mt-6 mb-4 justify-center">
                  <v-btn class="primary mx-0 btn-search" @click="search">
                    <v-icon>mdi-dropdown</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
  
</template>

<script>
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      type: Object,
      default: () => ({
        orderCode: '',
        receiptCode: '',
        createdAtFrom: null,
        createdAtTo: null,
        paymentAtFrom: null,
        paymentAtTo: null,
      }),
    },
  },
  data() {
    return {
      openMenu: false,
      statusOptions: [
        { text: 'Tất cả', value: '' },
        { text: 'Thành công', value: 'success' },
        { text: 'Đang xử lý', value: 'pending' },
        { text: 'Thất bại', value: 'failed' },
      ],
    }
  },
  computed: {
    createdAtRange: {
      get() {
        if (this.filterForm.createdAtFrom && this.filterForm.createdAtTo) {
          return [this.filterForm.createdAtFrom, this.filterForm.createdAtTo]
        }
        return null
      },
      set(value) {
        if (value && Array.isArray(value) && value.length === 2) {
          this.$set(this.filterForm, 'createdAtFrom', value[0])
          this.$set(this.filterForm, 'createdAtTo', value[1])
        } else {
          this.$set(this.filterForm, 'createdAtFrom', null)
          this.$set(this.filterForm, 'createdAtTo', null)
        }
      }
    },
    paymentAtRange: {
      get() {
        if (this.filterForm.paymentAtFrom && this.filterForm.paymentAtTo) {
          return [this.filterForm.paymentAtFrom, this.filterForm.paymentAtTo]
        }
        return null
      },
      set(value) {
        if (value && Array.isArray(value) && value.length === 2) {
          this.$set(this.filterForm, 'paymentAtFrom', value[0])
          this.$set(this.filterForm, 'paymentAtTo', value[1])
        } else {
          this.$set(this.filterForm, 'paymentAtFrom', null)
          this.$set(this.filterForm, 'paymentAtTo', null)
        }
      }
    }
  },
  methods: {
    search() {
      this.openMenu = false
      Bus.$emit('qr-transaction-list-filter', this.filterForm)
    },
    exportExcel() {
      this.$emit('exportExcel')
    },
  },
}
</script>

<style lang="scss" scoped>
// Hiệu ứng hover cho button Xuất file Excel
.btn-export-excel {
  background-color: #e91e63 !important;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #c2185b !important;
  }
}

// Hiệu ứng hover cho button Lọc theo điều kiện
.btn-filter-condition {
  background-color: #e91e63 !important;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #c2185b !important;
  }
}

// Icon close - hover với background màu xám hình tròn
.icon-close {
  cursor: pointer;
  border-radius: 50%;
  padding: 4px;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
}

// Hiệu ứng hover cho button Tìm kiếm
.btn-search {
  background-color: #e91e63 !important;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #c2185b !important;
  }
}
</style>

